import { ValueList } from "appworks/utils/value-list";

export class SlotBetModel {
    // Free bet / promotion - i.e do not charge for spins
    public freeBet: boolean = false;

    public creditsPerLine: ValueList<number> = new ValueList();
    public creditSizes: ValueList<number> = new ValueList();
    public selectedLines: number[];

    // For games, such as ways, where the bet is not based on lines
    public fixedBetCost: number = 0;

    // Games with additional bets that should be included in the total stake
    public additionalBet: number = 0;
}
